const PROJET_ROW_TYPE = {
	PROJET: 'P',
	COMPOSANT: 'C',
};

export default PROJET_ROW_TYPE;
